import { render, staticRenderFns } from "./FooterToolBar.vue?vue&type=template&id=663767e8&scoped=true"
import script from "./FooterToolBar.vue?vue&type=script&lang=js"
export * from "./FooterToolBar.vue?vue&type=script&lang=js"
import style0 from "./FooterToolBar.vue?vue&type=style&index=0&id=663767e8&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663767e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('663767e8')) {
      api.createRecord('663767e8', component.options)
    } else {
      api.reload('663767e8', component.options)
    }
    module.hot.accept("./FooterToolBar.vue?vue&type=template&id=663767e8&scoped=true", function () {
      api.rerender('663767e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tools/FooterToolBar.vue"
export default component.exports